import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../../keycloack/auth.service';
import { ROLES } from '../../utils/constants';

@Component({
  selector: 'app-home-redirect',
  standalone: true,
  template: '',
})
export class HomeRedirectComponent implements OnInit {
  constructor(private router: Router, private authService: AuthService) {}

  ngOnInit(): void {
    if (this.authService.hasRole(ROLES.superadmin)) {
      this.router.navigate(['/superadmin/tenants']);
    } else if (this.authService.hasRole(ROLES.admin) || this.authService.hasRole(ROLES.gestore) || this.authService.hasRole(ROLES.esperto)) {
      this.router.navigate(['/avvisi']);
    } else if (this.authService.hasRole(ROLES.supporto) || this.authService.hasRole(ROLES.asset)) {
      this.router.navigate(['/ticketing']);
    } else {
      this.router.navigate(['/error']);
    }
  }
}
